module.exports = __webpack_public_path__ + "img/13order.451401bd.png";